import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import MaritalStatusForm from './MaritalStatusForm';

const MaritalStatusActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const MaritalStatusCreate = (props: any) => {
  return (
    <Create actions={<MaritalStatusActions {...props} />} {...props}>
      <MaritalStatusForm />
    </Create>
  );
};

export default MaritalStatusCreate;
